import React from 'react';
import { ChevronRightSmall } from '@wix/wix-ui-icons-common';

import { dataHooks } from '../constants';
import { classes } from '../SidebarSubMenuNext.st.css';

export type ExpandTrigger = 'click' | 'select';

export type CommonMenuProps = {
  title: React.ReactNode;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  children?: React.ReactNode;
  dataHook?: string;
  itemKey: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onExpand?: (trigger: ExpandTrigger) => void;
  onCollapse?: (trigger: ExpandTrigger) => void;
  onQuickNavOpen?: () => void;
} & {
  [key: string]: any;
};

const chevronSuffixJsx = (
  <span className={classes.chevronRight}>
    <ChevronRightSmall data-hook={dataHooks.chevronRight} size="18px" />
  </span>
);

export const getSuffixWithChevron = (suffix: React.ReactNode) => {
  if (!suffix) {
    return chevronSuffixJsx;
  }

  return Array.isArray(suffix)
    ? [suffix[0], chevronSuffixJsx]
    : [suffix, chevronSuffixJsx];
};
